import { useQuery } from "@tanstack/react-query";
import { Descriptions } from "@/components/v2";
import { Card, Button } from "@rumbledirect/ui";
import { EditOutlined } from "@ant-design/icons";
import { Space, type DescriptionsProps } from "antd";
import { Link, useParams } from "react-router-dom";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";
import { fetchRootServicePartnerById } from "@/lib/api/resources/rootServicePartners";

const formatAddress = (address?: ServicePartner["address"] | null) => {
  if (!address?.street) return null;

  const line1 = [
    address.street,
    address.streetNumber,
    address.streetNumberAddition,
  ]
    .filter(Boolean)
    .join(" ");
  const line2 = [address.postalCode, address.city].filter(Boolean).join(" ");

  return (
    <div>
      <div>{line1}</div>
      {line2 ? <div>{line2}</div> : null}
    </div>
  );
};

export const RootServicepartnerDetail = () => {
  const { id } = useParams();

  const query = useQuery({
    queryKey: ["root-service-partners", id],
    queryFn: () => {
      if (!id) throw new Error("No service partner ID provided");
      return fetchRootServicePartnerById(id);
    },
    enabled: !!id,
  });

  if (!id) return null;

  const items: DescriptionsProps["items"] = [
    { label: "Naam", children: query.data?.name ?? null },
    { label: "Groep", children: query.data?.groupName ?? null },
    { label: "E-mail", children: query.data?.email ?? null },
    { label: "Telefoon", children: query.data?.telephone ?? null },
    { label: "Website", children: query.data?.website ?? null },
    {
      label: "Externe referentie",
      children: query.data?.externalReference ?? null,
    },
    {
      label: "Audabox nummer",
      children: query.data?.dwproAudaboxNumber ?? null,
    },
    { label: "Adres", children: formatAddress(query.data?.address) },
    {
      label: "Postadres",
      children: formatAddress(query.data?.postalAddress),
    },
  ];

  return (
    <Card
      title="ServicePartner"
      loading={query.isFetching}
      extra={
        <Space>
          <Link to={`/base/service-partners/${id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
